import React, { Component } from 'react';
import { connect } from "react-redux";
import { customizeSVG } from 'utils/customizeSVG.jsx';
import BentoLoginModal from 'components/__old/common/modals/bentoLogin';
import TabSettings from 'components/__old/common/tabSettings.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bento from "assets/images/logos/bento.svg";
import * as info from "store/entities/settingsInfo/action";

class Integrations extends Component {

    state = {
        showLoginModal: false,
    }
    
    
    goBack = () => {
        this.props.history.goBack();
    }


    toggleLoginModalSidebar = () => {
        const { showLoginModal } = this.state;
        this.setState({showLoginModal: !showLoginModal});
    }


    componentDidMount() {
        this.props.getInfo();
    }
    

    render() { 
        customizeSVG();
        const { showLoginModal } = this.state;
        const { companyInfoLoading, companyInfo } = this.props;

        return ( 
            <div>


                <BentoLoginModal
                    showLoginModal={showLoginModal}
                    toggleLoginModalSidebar={() => this.toggleLoginModalSidebar()}
                />

                
                <div className="flex">
                    <div className="flex-shrink-0">
                        <div className="page-title">
                            Settings
                        </div>
                    </div>
                    <div className="flex-grow flex space-x-3 justify-end">
                        <button className="btn btn-md btn-transparent-black" onClick={this.goBack}>
                            <FontAwesomeIcon icon="angle-left" className="text-lg" />
                            <span>
                                Back
                            </span>
                        </button>
                    </div>
                </div>


                <TabSettings />
                

                <div className="mt-8">
                    <div className="box">

                        {(companyInfoLoading === true) && 
                            <div className="table-info">
                                <FontAwesomeIcon icon="circle-notch" spin />
                                <div className="font-bold uppercase">
                                    Loading...
                                </div>
                            </div>
                        }

                        {(companyInfoLoading === false && companyInfo) && 
                            <>
                                <div className="font-bold text-gray-600">
                                    Configure Integration
                                </div>
                                <div className="mt-10 pt-4 pb-24">

                                    <div className="lg:flex justify-between">
                                        <div>
                                            <img src={bento} alt="Bento" className="w-48 object-contain" />
                                        </div>
                                        <div className="mt-6 lg:my-auto flex flex-col lg:items-end">
                                            <div className="w-full lg:text-center">
                                                You are logged in
                                            </div>
                                            <button type="button" className="mt-2 btn btn-ep-primary" onClick={this.toggleLoginModalSidebar}>
                                                Change Login Information
                                            </button>
                                            {/*
                                            <Link to="/settings/integrations/bento/manage" className="lg:mx-auto mt-3 inline-block hover:underline">
                                                Manage your account
                                            </Link>
                                            */}
                                        </div>
                                    </div>   
                                </div>
                            </>
                        }

                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    companyInfoLoading: state.entities.settingsInfo.getLoading,
    companyInfo: state.entities.settingsInfo.companyInfo.company,
});

const mapDispatchToProps = (dispatch) => ({
    getInfo: () => dispatch(info.getInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);